import {getNumber} from 'src/utils/numberUtils';
import * as Yup from 'yup';

const commonValidation = {
	images: Yup.array(),
	addedQuantity: Yup.number().typeError('يجب إدخال رقم').min(1, 'لا يمكن إدخال رقم أقل من 1'),
	cost_per_unit: Yup.number().typeError('يجب إدخال رقم').min(0, 'لا يمكن إدخال رقم أقل من 0'),
	name: Yup.string().required('يجب ادخال اسم المنتج ').max(100, 'يجب أن لا يزيد الاسم عن 100 حرف'),
	price: Yup.number().typeError('ادخل رقم صحيح').min(0, 'يجب ادخال السعر'),
	// weight: Yup.number().typeError('يجب ادخال وزن صحيح بالكيلو').min(0, 'ادخل وزن صحيح'),
	attrs: Yup.array().of(
		Yup.object().shape({
			name: Yup.string().required(),
			value: Yup.string().required(),
		}),
	),

	weight: Yup.number()
		.transform((value, originalValue) => getNumber(originalValue))
		.typeError('ادخل رقم صحيح')
		.nullable(),
	width: Yup.number()
		.transform((value, originalValue) => getNumber(originalValue))
		.typeError('ادخل رقم صحيح')
		.nullable(),
	height: Yup.number()
		.transform((value, originalValue) => getNumber(originalValue))
		.typeError('ادخل رقم صحيح')
		.nullable(),
	length: Yup.number()
		.transform((value, originalValue) => getNumber(originalValue))
		.typeError('ادخل رقم صحيح')
		.nullable(),
};
export const updateProductSchema = Yup.object().shape({
	...commonValidation,
});

export const addProductSchema = Yup.object().shape({
	...commonValidation,
	images: Yup.array(),
});
